
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function BlogHeader() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    // Clean up the event listener on component unmount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white shadow-sm'
      }`}
    >
      <nav className="w-full px-6 py-4" aria-label="Blog navigation">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <div className="flex items-center">
            <Link to="/" className="cursor-pointer">
              <img
                src="https://public.readdy.ai/ai/img_res/7a57d421-2c2a-46f2-8ebb-126e0217b520.png"
                alt="El Paso QuickBooks Bookkeeping Services - Professional Bookkeeper El Paso TX"
                title="El Paso QuickBooks Bookkeeping Services"
                className="h-12 w-auto"
              />
            </Link>
          </div>
          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className="text-sm font-medium text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Home
            </Link>
            <a
              href="/#services"
              className="text-sm font-medium text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Services
            </a>
            <a
              href="/#benefits"
              className="text-sm font-medium text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Why Choose Us
            </a>
            <Link
              to="/blog"
              className="text-sm font-medium text-teal-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Blog
            </Link>
            <a
              href="/#contact"
              className="bg-teal-500 text-white px-6 py-2 rounded-full text-sm font-medium hover:bg-teal-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Get Started
            </a>
          </div>
        </div>
      </nav>
    </header>
  );
}
